import { render } from "./Notification.vue?vue&type=template&id=2da70cde&scoped=true"
import script from "./Notification.vue?vue&type=script&lang=js"
export * from "./Notification.vue?vue&type=script&lang=js"

import "./Notification.vue?vue&type=style&index=0&id=2da70cde&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2da70cde"

export default script